module.exports = __webpack_public_path__ + "static/media/home.e05eab98.jfif";